'use client'

import { SWRConfig } from 'swr'

export default function SWRConfiguration({ children }: { children: React.ReactNode }) {
    return (
        <SWRConfig
            value={{
                refreshInterval: 0,
                revalidateIfStale: false,
                revalidateOnFocus: false,
                revalidateOnReconnect: false,
                revalidateOnMount: true,
                keepPreviousData: true, // Keep showing cached data during revalidation to prevent loading flashes during navigation
                focusThrottleInterval: 60000,
                errorRetryInterval: 1000,
                errorRetryCount: 3,
                loadingTimeout: 500 // we only show loading animations after 500ms
            }}
        >
            {children}
        </SWRConfig>
    )
}
